import { useEffect, useState, useRef } from "react";
import { ChangeAlertCallbackType, ChangeLoaderCallbackType } from "../../../Root";
import { closelightbox } from "../../../../util/Functions";
import { CommonService } from "../../../../services/CommonService";
import { useDialog } from "@albo-ui/core";
import { readCsvMultiple } from "../../../../util/ReadCsvMultiple";
import { ITOpsService } from "../../../../services/ITOpsService";

export const useInsertBQHandle = (open: boolean, changeAlert: ChangeAlertCallbackType, changeLoader: ChangeLoaderCallbackType) => {
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [zPos, setZPos] = useState(45);
    const dialogProps = useDialog();
    const commonService = useRef<CommonService>();
    const itopsService = useRef<ITOpsService>();
    const agent = localStorage.session ? JSON.parse(localStorage.session) : {};

    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [form, setForm] = useState(null);
    const [execute, setExecute] = useState(null);

    const parseJson = async (csv) => {
        changeLoader(true);
        setZPos(-1);
        setIsValidForm(true);
        setError(null);
        
        const request = await readCsvMultiple(csv, 50, ["customer_uuid", "status", "active", "type", "amount_max", "udate"]);
        if (request.OK) {
            setForm(JSON.parse(JSON.stringify(request)));
            setIsValidForm(false);
        } else {
            changeAlert(true, "error", request.error || "Ocurrió un error, por favor intenta de nuevo.");
        }

        changeLoader(false);
        setZPos(45);
    };

    const onClose = () => {
        dialogProps.onClose();
    };

    const onConfirm = async () => {
        changeLoader(true);
        setZPos(-1);

        const payload = {rows: form["rows"], agent: agent["uuid"]};
        const response = await itopsService.current.insertBqChargeback(payload);
        if (response?.data?.response === "OK") {
			changeAlert(true, 'success', "Carga ejecutada con éxito.");
            changeLoader(false);
            closelightbox();
        } else {
			changeAlert(true, 'error', response["message"] || response["data"]["message"] || "Error al cargar registros.");
            changeLoader(false);
            setZPos(45);
        }
    };

    const onDownloadFile = async () => {
        changeLoader(false);
        let path = "formats/workers.xlsx";
        if (path) {
            const request = await commonService.current.downloadFile(path);
            if (request.data.response === "OK") {
                window.open(request.data.content, "_blank");
            }
        }
        changeLoader(false);
    };

    const onFormReset = () => {
        setForm(null);
        setError(null);
        setIsValidForm(true);
    };

    useEffect(() => {
        commonService.current = new CommonService(changeAlert);
        itopsService.current = new ITOpsService(changeAlert);

        if (!open) {
            setData([]);
            setForm(null);
            setError(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return {
        data,
        form,
        zPos,
        isValidForm,
        error,
        execute,
        onClose,
        onConfirm,
        onFormReset,
        setExecute,
        parseJson, 
        onDownloadFile
    };
};
